import React, { Component, PropType } from 'react'
import Share from './Share';
import { MentionsInput, Mention } from 'react-mentions'
import { set_initial_values_url } from '../../actions/index';
import defaultStyle from './defaultStyle'
import defaultMentionStyle from './defaultMentionStyle'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import { setQuestion } from '../../actions/index'

var AlfredStyle = { padding: '0px', width: "90%", float: "left" };
var FilterStyle = { width: "5%", float: "left", marginLeft: '0px', padding: '0px' };
var DataSetStyle = { width: "5%", float: "left", marginLeft: '0px', padding: '0px' };
var alfredComDiv = { position: 'relative', overflow: 'initial', zIndex: "10", height: "45px", marginTop: '10px', backgroundColor: '#fafafa' };
var feedbackStyle = { textAlign: "right", marginRight: "34px", marginTop: "-26px" };
var feedbackRadio = { paddingLeft: "5%" };
var AlfredSearchDisplay = {}
let microphoneColor='grey' ;

var descriptionListStyle = {
    lineHeight: '20px',
    cursor: 'auto',
    background: 'rgba(247, 247, 247, 0.26)',
    marginTop: '5px',
    borderTop: '1px solid #dddddd',
    borderBottom: '1px solid #dddddd',
    borderRight: '1px solid #dddddd'
};

var descriptionLabelStyle = {
    width: '100%',
    padding: "15px 0px"
};

var descriptionDivStyle = {
    padding: '0px',
    float: "left"
};

var descriptionFeedbackStyle = {
    padding: '0px',
    fontSize: "15px",
    textAlign: "right",
    paddingRight: "20px"
};

class AlfredComponent extends React.Component {
    constructor(props) {
        super(props);
        if (props.data == undefined) {
            this.state = {
                data: {
                    data: null,
                    type: 'sample'
                },
            };
        }
        else if (props.question) {
            this.state = {
                data: {
                    type: "sample"
                },
                query: props.question
            }
        }
        else this.state = props.data;

        this.state = {
            question: '',
            questionId: '',
            type: "sample"
        }
        this.getData = this.getData.bind(this);
        this.SubmitHandle = this.SubmitHandle.bind(this);
    }
    // SubmitHandle= (e)=>{
    //     e.preventDefault();
    //     this.search('/api/alfred');
    //     return false;
    // }
    saveComment = () => {
        saveComment();
    }
    saveUserComment = () => {
        saveUserComment();
    }
    ChangeHandle = (e, newValue, newPlainTextValue, mentions) => {
        newPlainTextValue = newPlainTextValue == "" ? "empty_query" : newPlainTextValue;
        this.setState({
            query: newPlainTextValue
        })
    }
    keyEventHandle = (e) => {
        if (e.keyCode == 13) {
            this.SubmitHandle(e);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.data) {
            this.setState({
                query: nextProps.data.question,
                questionId: nextProps.data.questionId
            })
        } else {
            if (nextProps.question)
                this.setState({
                    query: nextProps.question,
                    questionId: nextProps.questionId
                })
            else this.setState({
                query: "",
                questionId: ''
            })
        }
    }
    getInitialState() {
        if (this.props.data == undefined) {
            return {
                data: {
                    data: null,
                    type: 'sample'
                }
            };
        }
        else if (this.props.question) {
            return {
                data: {
                    type: "sample"
                },
                query: this.props.question
            }
        }
        else return this.props.data;
    }
    QueryChange = (e) => {
        this.state.query = e.target.textContent;
        this.forceUpdate();
    }
    SubmitHandle = (e) => {
        e.preventDefault();
        jQuery(".se-pre-con").fadeIn("slow");
        var voice = 0;
        var that = this;
        if (this.state.voice)
            voice = 1;
        var dataset = JSON.parse(localStorage.Dataset);
        var userId = this.props.authData ? this.props.authData.userId : null;
        var authorization_value = null;
        authorization_value = "Basic " + btoa(userId + ":");

        // var query = this.statoolTipConfigte.query ? this.state.query : document.getElementById('message_body').value;
        var query = document.getElementById('message_body').value;
        if (alfredConfig == 'yes') {
            that.props.setQuestion({ "alfred_question": query });
        }

        if (query && query != "empty_query") {
            let params = {
                siteId: dataset.siteId,
                toolId: dataset.toolId,
                query: query,
                type: "dashboard"
            }
            CallAPI('GET', '/app/alfred', null, params, 0, function (response) {
                checkIfSessionTimedOut(response)
                checkIfMaintenanceModeOn(response)
                if (response == null) {
                    var win = window.open("/dashboard/oops", "_self");
                }
                else {
                    let removeGlobalFilter = response?.removeGlobalFilter
                    let ytdcagr = response?.actualParam.ytdcagr ? response.actualParam.ytdcagr : "";
                    response = response['url'];
                    var new_alfred_url = response.split("?");
                    var alfred_url_params = new URLSearchParams(new_alfred_url[1]);
                    var object_alfred_data = {}
                    object_alfred_data.metric = alfred_url_params.get("selectedMetric") ? alfred_url_params.get("selectedMetric") : alfred_url_params.get("metric");
                    object_alfred_data.property = alfred_url_params.get("property");
                    object_alfred_data.breakup = alfred_url_params.get("breakup");
                    object_alfred_data.include = alfred_url_params.get("include");
                    object_alfred_data.exclude = object_alfred_data.exclude == 'Blanks;null' ? '' : object_alfred_data.exclude
                    object_alfred_data.insightMetric = alfred_url_params.get("insightMetric");
                    object_alfred_data.startDate = alfred_url_params.get("startDate");
                    object_alfred_data.endDate = alfred_url_params.get("endDate");
                    object_alfred_data.point = alfred_url_params.get("insightPoint");
                    object_alfred_data.sortOrder = alfred_url_params.get("sortOrder")
                    object_alfred_data.limit = alfred_url_params.get("limit")
                    object_alfred_data.multiDim = alfred_url_params.get("multiDim") ? alfred_url_params.get("multiDim") : true
                    object_alfred_data.metricRange = alfred_url_params.get("metricRange") ? alfred_url_params.get("metricRange") : null;
                    object_alfred_data.period = alfred_url_params.get("period") ? alfred_url_params.get("period") : alfred_url_params.get("chartType");
                    object_alfred_data.period = object_alfred_data.period ? object_alfred_data.period : "Aggregate";
                    object_alfred_data.insight = alfred_url_params.get("false");
                    object_alfred_data.analysis = alfred_url_params.get("analysis");
                    object_alfred_data.clusterCount = alfred_url_params.get("clusterCount");
                    object_alfred_data.compare = false;
                    object_alfred_data.sortMetric = alfred_url_params.get("sortMetric")?alfred_url_params.get("sortMetric"):null;
                    object_alfred_data.cagrPoint = alfred_url_params.get("cagrPoint")?alfred_url_params.get("cagrPoint"):null;
                    object_alfred_data.prevStartDate = alfred_url_params.get("prevStartDate") ? alfred_url_params.get("prevStartDate") : null;
                    object_alfred_data.prevEndDate = alfred_url_params.get("prevEndDate") ? alfred_url_params.get("prevEndDate") :null;
                    object_alfred_data.question = alfred_url_params.get("question");
                    if(removeGlobalFilter){
                        object_alfred_data.removeGlobalFilter = removeGlobalFilter? removeGlobalFilter:"";
                    }
                    // if(ytdcagr && ytdcagr != "null" && ytdcagr != "undefined"){
                        object_alfred_data.ytdcagr = ytdcagr
                    // }


                    if (alfred_url_params.get("dashboard_id")) {
                        id_dashboard = alfred_url_params.get("dashboard_id")
                    }
                    var redirect_path = new_alfred_url[0].split("/");
                    redirect_path = that.urlMapping(redirect_path, alfred_url_params);
                    let urlBind = that.createURL(object_alfred_data);
                    if (redirect_path.indexOf("?") >= 0) {
                        urlBind = urlBind.replace("?", "&");
                    }
                    that.props.set_initial_values_url(object_alfred_data)
                    that.props.allProps.props.history.push(`${redirect_path}${urlBind}`)
                }
            }, this.props.authData)

            /* Commented below jQuery.ajax api call & changed it to above CallAPI method */
            // jQuery.ajax({
            //     type: 'Get',
            //     data: { siteId: dataset.siteId, toolId: dataset.toolId, query: query, type: "dashboard" },
            //     headers: { Authorization: authorization_value },
            //     url: '/app/alfred',
            //     success: function (response) {
            //         checkIfSessionTimedOut(response)
            //         if (response == null) {
            //             var win = window.open("/dashboard/oops", "_self");
            //         }
            //         else {
            //             response = response['url'];
            //             var new_alfred_url = response.split("?");
            //             var alfred_url_params = new URLSearchParams(new_alfred_url[1]);
            //             var object_alfred_data = {}
            //             object_alfred_data.metric = alfred_url_params.get("selectedMetric") ? alfred_url_params.get("selectedMetric") : alfred_url_params.get("metric");
            //             object_alfred_data.property = alfred_url_params.get("property");
            //             object_alfred_data.breakup = alfred_url_params.get("breakup");
            //             object_alfred_data.include = alfred_url_params.get("include");
            //             object_alfred_data.exclude = object_alfred_data.exclude == 'Blanks;null' ? '' : object_alfred_data.exclude
            //             object_alfred_data.insightMetric = alfred_url_params.get("insightMetric");
            //             object_alfred_data.startDate = alfred_url_params.get("startDate");
            //             object_alfred_data.endDate = alfred_url_params.get("endDate");
            //             object_alfred_data.point = alfred_url_params.get("insightPoint");
            //             object_alfred_data.sortOrder = alfred_url_params.get("sortOrder")
            //             object_alfred_data.limit = alfred_url_params.get("limit")
            //             object_alfred_data.multiDim = alfred_url_params.get("multiDim") ? alfred_url_params.get("multiDim") : true
            //             object_alfred_data.metricRange = alfred_url_params.get("metricRange") ? alfred_url_params.get("metricRange") : null;
            //             object_alfred_data.period = alfred_url_params.get("period") ? alfred_url_params.get("period") : alfred_url_params.get("chartType");
            //             object_alfred_data.period = object_alfred_data.period ? object_alfred_data.period : "Aggregate";
            //             object_alfred_data.insight = alfred_url_params.get("false");
            //             object_alfred_data.analysis = alfred_url_params.get("analysis");
            //             object_alfred_data.clusterCount = alfred_url_params.get("clusterCount");
            //             object_alfred_data.compare = false;

            //             object_alfred_data.question = alfred_url_params.get("question");

            //             if(alfred_url_params.get("dashboard_id")) {
            //                 id_dashboard = alfred_url_params.get("dashboard_id")
            //             }
            //             var redirect_path = new_alfred_url[0].split("/");
            //             redirect_path = this.urlMapping(redirect_path, alfred_url_params);
            //             let urlBind = this.createURL(object_alfred_data);
            //             if(redirect_path.indexOf("?")>=0){
            //                 urlBind = urlBind.replace("?","&");
            //             }
            //             that.props.allProps.props.history.push(`${redirect_path}${urlBind}`)

            //             that.props.set_initial_values_url(object_alfred_data)
            //         }
            //     }.bind(this)
            // });
        }
        return false;
    }

    createURL(data){
        var finalURL = "?";
        Object.keys(data).map(function(innerData){
            finalURL += finalURL=="?" ? "" : "&";
            finalURL += `${innerData}=${data[innerData]}`;
        })
        return finalURL
    }

    urlMapping(path, params){
        let new_path = path[path.length-1];
        let final_path = null;
        switch(new_path){
            case "charttype":
                let chartCat = params.get("chartCat");
                final_path=`/chart/chartData?chartCat=${chartCat}`;
                break;            
            default:
                var addPath = ''
                // if(path[0] === 'pinboard' || path[1] === 'pinboard')
                if (path.includes('pinboard'))
                    addPath = '/pinboard'
                final_path=`${addPath}/${new_path}`;
                break
        }
        return final_path;
    }

    componentDidMount = () => {
        jQuery('[data-toggle="tooltip"]').tooltip();
        if(SKIN_MODE=="dark"){
            jQuery("#message_body").css({"color":"white"})
        }
        // closeSidebar('FilterDiv');
        var url = document.location.pathname;
        if (jQuery(window).width() > 1000) {
            if (url == '/dashboard/charttype' || url == "/dashboard/summary" || url == '/dashboard/report' || url == '/dashboard/hyperlocal' || url == '/dashboard/dashboard') {
                closeSidebar('FilterDiv');
                jQuery("#main-content").css("marginRight", "0px");
                // openSidebar('FilterDiv', "387px");
                // jQuery("#main-content").css("marginRight", "380px");
            } else {
                AlfredStyle = { padding: '0px', width: "95%", float: "left" };
                FilterStyle = { display: "none" };
                // closeSidebar('FilterDiv');
            }
        } else {
            alfredComDiv = { position: 'relative', overflow: 'initial', zIndex: "10", height: "45px", marginTop: '50px', backgroundColor: '#fafafa' };
            DataSetStyle = { width: "12%", float: "left", marginLeft: '0px', padding: '0px' };
            if (url == '/dashboard/charttype' || url == "/dashboard/summary" || url == '/dashboard/report' || url == '/dashboard/hyperlocal' || url == '/dashboard/dashboard') {
                //if less than 1000 px
                closeSidebar('FilterDiv');
                jQuery("#main-content").css("marginRight", "0px");
                AlfredStyle = { padding: '0px', width: "76%", float: "left" };
                FilterStyle = { width: "12%", float: "left", marginLeft: '0px', padding: '0px' };
            } else {
                AlfredStyle = { padding: '0px', width: "88%", float: "left" };
                FilterStyle = { display: "none" };
                this.setState();
                // closeSidebar('FilterDiv');
            }
        }
    }
    openSetting = () => {
        var props = this.props.allProps;
        if (props.refs.sidebarInsightRef.handleInsightEnable)
            props.refs.sidebarInsightRef.handleInsightEnable(false);
        var width = (document.getElementById('FilterDiv').style.width).replace('px', '');
        if (width <= 0) {
            if (jQuery(window).width() > mobile_width) {
                openSidebar('FilterDiv', filter_desktop_width);
                jQuery("#main-content").css("marginRight", main_content_div_filter);
            } else {
                openSidebar('FilterDiv', filter_mobile_width);
            }
        } else {
            closeSidebar('FilterDiv');
            jQuery("#main-content").css("marginRight", "0px");
        }
        var width = document.getElementById('SidebarInsightDiv')
        if (width && width.clientWidth)
            closeSidebar('SidebarInsightDiv');
        var url = document.location.pathname;
        if (url == '/dashboard/charttype' && highChartsDiv) {
            highChartsDiv.reflow();
        }
        if (url == '/dashboard/dashboard' && highChartsDiv) {
            highChartsDiv.map(function (innerData, index) {
                highChartsDiv[index].reflow();
            })
        }
    }
    getData = (search, callback) => {
        asyncFilter(search, 'alfred', callback, this.props.authData);
    }
    getMetricData = (search, callback) => {
        asyncFilter(search, 'metric', callback, this.props.authData);
    }
    speechtoText = (e) => {
        if (window.hasOwnProperty('webkitSpeechRecognition')) {

            jQuery("#alfredText").addClass("activeVoice");

            var recognition = new webkitSpeechRecognition();

            recognition.continuous = false;
            recognition.interimResults = false;

            recognition.lang = "en-US";
            recognition.start();
            this.setState({ voice: 1 });
            recognition.onresult = function (e) {
                document.getElementById('message_body').value = e.results[0][0].transcript;
                console.log(e.results[0][0].transcript);
                recognition.stop();
                jQuery("#alfredText").removeClass("activeVoice");
                setTimeout(function () {
                    document.getElementById('alfredSearch').click();
                }, 1000);

                // document.getElementById('labnol').submit();
            };

            recognition.onerror = function (e) {
                recognition.stop();
            }

        }
    }
    openComment = (type, e) => {
        openComment(type, e);
    }
    changedataset = (toolId, siteId, name) => {
        if (main_siteId != siteId) {
            window.open("/dashboard/start", "_self");
        } else {
            if (window.location.search) {
                var url = window.location.pathname + window.location.search;
                url = url.replace('&toolId=' + encodeURI(mainToolId), '') + "&";
            }
            else var url = window.location.pathname + "?";
            url = url + "toolId=" + toolId + "&name=" + name;
            window.open(url, "_self");
        }
    }

    handleChange = (type, target, data) => {
        let tempData = this.state.formData;
        if (type == "input"){
            let fileName = data.target.value;
            let textSplit = fileName.split('.');
            if(textSplit[1] !== 'csv'){
                alert("Please upload CSV file only!");
                return false;
            }
            tempData[target] = fileName;
            this.setState({ formData: tempData});
        }
        else if (type == "select") {
            tempData[target] = data;
            this.setState({ formData: tempData });
        }
    }

    render() {
        var index = 0;
        var feedbackDislikeId = 'Alfred_' + this.state.questionId + '_Dislike';
        var feedbackLikeId = 'Alfred_' + this.state.questionId + '_Like';
        var that=this;
        var list_dataset=null;
        if (this.props.users)
            var shareComponent = <Share users={this.props.users} />;
        else
            var shareComponent = null;
        // jQuery(jQuery("input.form-control")[0]).focus();
        
        var query = this.state.query == 'null' || this.state.query == 'undefined' || !this.state.query ? '' : this.state.query;
        query = query ? query : this.props.question;

        query = query ? query : "";
        query = query == "empty_query" ? "" : query;
        // query = decodeURIComponent(query);    
        if(this.state.questionId) {
            // var feedbackComponent = <div className="col-md-2 pull-right" style={feedbackStyle}>
            var feedbackComponent = <nav className="nav">
                {/* <a href="#" className="nav-link" onClick={this.speechtoText} id="alfredText"><i data-feather="mic"></i></a> */}
                <a href="#" className="nav-link" onClick={this.openComment.bind(this, 'like')}><i data-feather="thumbs-up" id={feedbackLikeId}></i></a>
                <a href="#" className="nav-link" onClick={this.openComment.bind(this, 'disLike')}><i data-feather="thumbs-down" id={feedbackDislikeId}></i></a>
            </nav>
        }else{
            var feedbackComponent = <nav className="nav">
                {/* <a className="nav-link" onClick={this.speechtoText} id="alfredText"><i data-feather="mic"></i></a> */}
            </nav>
        }        
        // if(dataset){
        //     list_dataset=JSON.parse(dataset).map(function(innerData,index){
        //         if(innerData.toolId==mainToolId)
        //             return <li key={"dataset"+index} style={{backgroundColor:"#c5c5c5"}}><a onClick={that.changedataset.bind(this,innerData.toolId,innerData.siteId,innerData.name)} href="#" style={{fontSize:"14px"}}>{innerData.name}</a></li>;
        //         else return <li key={"dataset"+index}><a onClick={that.changedataset.bind(this,innerData.toolId,innerData.siteId,innerData.name)} href="#" style={{fontSize:"14px"}}>{innerData.name}</a></li>;
        //     })
        // }

        // var dataset_button=<div className="btn-group dropdown" style={{position:'absolute',zIndex:"1"}}>
        //     <button className="btn btn-contrast dropdown-toggle" data-toggle="dropdown" style={{marginBottom:"5px",paddingLeft:'10px'}}><i className="fa fa-database" style={{marginRight:"5px"}}></i><span className="caret"></span></button>
        //     <ul className="dropdown-menu">
        //         <li><a href="/dashboard/start">Go to Dataset Page</a></li>
        //         {list_dataset}
        //     </ul>
        // </div>;
        var autoFocus_input=true;
        if (jQuery(window).width() < 600)
            autoFocus_input=false;
        // const emailRegex = /(((?:^|\s)(@([^@]*))$))/;
        if(!checkIfFeatureApplicable('Search Bar')) {
            AlfredSearchDisplay = { display: 'none'}            
        }  
        // if (jQuery(window).width() < mobile_width){
        //      microphoneColor = 'white'
        // }
        let extraAlfredStyle = {
            // position: "relative",
            // overflowY: "hidden",
            // width: "100%",
            
            // textOverflow: "ellipsis",
            // whiteSpace: "nowrap",
        }      
        return (
            <div className="content-header bg-white bd-b-1" style={{...AlfredSearchDisplay, borderBottomWidth:"1px "}}>
                {shareComponent}
                <div id="userCommentModal" className="modal fade" role="dialog">
                    <div className="modal-dialog" style={{ width: '350px' }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button aria-hidden="true" className="close" data-dismiss="modal" type="button">Ã—</button>
                                <h5 className="modal-title">Comment</h5>
                            </div>
                            <div className="modal-body box" id="comment-body" style={{ overflow: 'hidden', padding: "20px" }}>
                                <textarea className='form-control' placeholder="Comment..." rows='6' id='UserComment'></textarea>
                                <input type='hidden' id='hiddenCommentId' name="" value='' />
                                <button className="btn btn-contrast pull-right" id="sendComment" onClick={this.saveUserComment} style={{ marginTop: '5px', marginBottom: '-7%' }}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-search d-flex justify-content-start h-100 align-items-center">
                    {/* <form autoComplete='off' id='botForm' action='#' method="POST" acceptCharset="UTF-8" onSubmit={this.SubmitHandle}> */}
                        {/* {dataset_button} */}
                        <a  id="alfredSearch" onClick={this.SubmitHandle}><i data-feather="search" style={{color:"gray", marginLeft:"-5px"}}></i></a>

                        <MentionsInput id='message_body' classNames={{mentions__input: 'form-control'}} autoFocus={autoFocus_input} placeholder="Ask your questions here.." value={query} onfocus="blur();" onChange={this.ChangeHandle.bind(this)} allowSpaceInQuery={true} singleLine={true} onKeyDown={this.keyEventHandle.bind(this)} rows={1} style={{...defaultStyle, ...extraAlfredStyle}} autoComplete='off'>
                            <Mention trigger="@"
                                data={this.getData}
                                renderSuggestion={(suggestion, search, highlightedDisplay) => (
                                    <div className="mentionRenderUI">
                                        {highlightedDisplay}
                                    </div>
                                )} style={defaultMentionStyle} />
                            <Mention trigger="#"
                                data={this.getMetricData}
                                renderSuggestion={(suggestion, search, highlightedDisplay) => (
                                    <div className="mentionRenderUI">
                                        {highlightedDisplay}
                                    </div>
                                )} style={defaultMentionStyle} />
                            {/* <Mention trigger={/((.*))/} */}
                            {/* <Mention trigger={/(([a-zA-Z\d]+$))/}
                                data={this.getAllData}                                
                                style={defaultMentionStyle} /> */}
                        </MentionsInput>
                        {/* <i className="fa fa-search search1" id="alfredSearch" aria-hidden="true" onClick={this.SubmitHandle} style={{ border: '4px solid white', backgroundColor: 'white', margin: '-6px -8px 0px 7px', fontSize: "20px" }}></i> */}
                        <i className="fa fa-microphone search1 microphoneColor" id="alfredText" aria-hidden="true" onClick={this.speechtoText} ></i> 
                        {/* {feedbackComponent}
                    {/* </form> */}
                </div>
                {feedbackComponent}
                
            </div>
        );
    }
};

function mapStateToProps(state) {
    return {
        authData: state.dataSet.authData,
        dataResult: state.dataSet.dataResult,
        dataSet: state.dataSet.dataSet

    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        set_initial_values_url,setQuestion
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AlfredComponent)